import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type AnonymousProfile = {
  partner?: string;

  // base setters
  setField: (field: AnonymousField, value?: string) => void
  setFields: (fields: Partial<AnonymousValues>) => void;

  // shorthand for individual fields
  setPartner: (value?: string) => void;
}

type AnonymousValues = Omit<AnonymousProfile, 'setField' | 'setFields' | 'setPartner'>;
type AnonymousField = keyof AnonymousValues;

export const useAnonymousProfile = create<AnonymousProfile>()(
  persist(
    (set, get) => ({
      partner: undefined,

      /**
       * setField acts as an override when
       * there is a new value inbound
       */
      setField: (field, value) => {
        const current = get()[field];

        if (value && current !== value) {
            set({ [field]: value });
        }
      },

      /**
       * Sets multiple fields all at once
       */
      setFields: (fields) => {
        Object.entries(fields).forEach(([key, value]) => {
            get().setField(key as keyof AnonymousValues, value);
        });
      },

      // shorthand for setting specific fields
      setPartner: (value) => get().setField('partner', value),

    }),
    {
      name: 'catch-profile',
      onRehydrateStorage: () => (state) => {

        // migrate from storage key to new field
        const migrateField = (storageKey: string, field: AnonymousField) => {
          try {
            if (!state?.[field]) {
              const originalValue = localStorage.getItem(storageKey);
              const formattedValue = originalValue ? JSON.parse(originalValue) : undefined;
              state?.setField(field, formattedValue);
              localStorage.removeItem(storageKey);
            }
          } catch {
            console.log('There was an error migrating', storageKey);
          }
        }
        
        // add additional migrations here as needed
        migrateField('catch_partner', 'partner');
      }
    },
  ),
)
